import {chat} from '../../data/discussion';

export const ACTION_GET_VIDEO_DISCUSSION = 'ACTION_GET_VIDEO_DISCUSSION';

export function getDiscussion() {
    return {
        type: ACTION_GET_VIDEO_DISCUSSION,
        payload: chat
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/discussionActions.js